var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import DataTable from '@/components/data-table/DataTable';
import PageHeader from '@/components/page-header/PageHeader';
import ErrorHandler from '@/support/ErrorHandler';
import { LessonType } from '@/models/LessonType';
import AddLessonTypeDialog from '@/views/LessonTypes/AddLessonTypeDialog';
import EditLessonTypeDialog from '@/views/LessonTypes/EditLessonTypeDialog';
import { lessonTypeIcons } from '@/support/Icon';
import { iconToHtml } from '@/support/String';
let LessonTypes = class LessonTypes extends Vue {
    constructor() {
        super(...arguments);
        this.selected = [];
        this.lessonType = new LessonType();
        this.selectedLessonType = new LessonType();
        this.isCreatingLessonType = false;
        this.isEditingLessonType = false;
    }
    get tableOptions() {
        return {
            headers: [
                {
                    text: '',
                    value: 'icon',
                    transform: (icon) => {
                        return iconToHtml(lessonTypeIcons[icon]);
                    },
                },
                {
                    text: this.$t('name.title').toString(),
                    value: 'name',
                },
            ],
            actions: [
                {
                    type: 'edit',
                    label: 'edit',
                    icon: 'edit',
                    action: (action, lessonType) => {
                        this.handleTableEdit(lessonType);
                    },
                },
                {
                    type: 'delete',
                    label: 'delete',
                    icon: 'delete',
                    action: (vm, lessonType) => {
                        this.handleTableDelete(lessonType);
                    },
                },
            ],
            filters: [],
            dropdown: [],
            model: new LessonType(),
        };
    }
    handleTableEdit(lessonType) {
        this.selectedLessonType = lessonType;
        this.isEditingLessonType = true;
    }
    handleTableDelete(lessonType) {
        this.selectedLessonType = lessonType;
        this.$store.dispatch('openDialog', this.dialogOptions);
    }
    get dialogOptions() {
        const lessonType = this.selectedLessonType;
        return {
            title: lessonType.name || this.$t('dialogOptions.confirmation').toString(),
            text: this.$tc('dialogOptions.delete', 1, { item: this.$t('dialogOptions.item.lessonType') }).toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.delete').toString(),
                    action: () => {
                        if (!lessonType) {
                            return;
                        }
                        lessonType
                            .delete()
                            .then((response) => {
                            if (response) {
                                this.selectedLessonType = new LessonType();
                                this.refreshDataTable();
                            }
                        })
                            .catch((error) => {
                            ErrorHandler.network(error);
                        });
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                    action: () => {
                        this.selectedLessonType = new LessonType();
                    },
                },
            },
        };
    }
    refreshFilterStore() {
        new LessonType()
            .all()
            .then((lessonTypes) => {
            const mutatedLessonTypes = [];
            const payload = {};
            lessonTypes.forEach((room) => {
                mutatedLessonTypes.push({
                    value: room.id,
                    text: room.getFilterLabel(),
                });
            });
            payload.LessonType = mutatedLessonTypes;
            this.$store.dispatch('updateLessonTypes', payload);
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    refreshDataTable() {
        this.refreshFilterStore();
        document.dispatchEvent(new CustomEvent('datatable:hook', {
            detail: (dataTable) => {
                dataTable.refresh();
            },
        }));
    }
};
LessonTypes = __decorate([
    Component({
        components: {
            DataTable,
            PageHeader,
            AddLessonTypeDialog,
            EditLessonTypeDialog,
        },
    })
], LessonTypes);
export default LessonTypes;
